import { HttpClient } from "@/app/api/HttpClient"
import { API_REDIX_CACHE_PATH } from "@/constants/prefix-path-api"
import { REDIS_CACHE } from "@/constants/admin-paths"

import { message } from "antd"

export const REDIS_CONTENT_TYPES = {
    POST: "posts",
    PAGE: "pages",
    CATEGORY: "categories",
    CAREER: "careers",
    EVENT: "events",
    BANNER: "banners",
    CAMPAIGN: "campaigns",
    VIDEO: "videos",
    YOUTUBE_VIDEO: "youtube-videos",
    TAG: "tags",
    STORE: "stores",
    LETAK: "letaks",
    WEBSITE: "websites",
  DICTIONARY: "translations",
}

export const flushAllRedisCache = async () => {
    try {
        const response = await HttpClient.post(`${API_REDIX_CACHE_PATH}${REDIS_CACHE.ALL.PATH}`)
        return response
    } catch (error) {
        console.error("Error flushing all redis cache:", error)
        throw error
    }
}

export const flushRedisCacheByContentType = async (contentType: string) => {
    try {
        const response = await HttpClient.post(`${API_REDIX_CACHE_PATH}${REDIS_CACHE.BY_CONTENT_TYPE.PATH}${contentType}`)
        return response
    } catch (error) {
        console.error(`Error flushing redis cache for ${contentType}:`, error)
        message.warning(`Không thể xóa Redis cache cho ${contentType}`)
    }
}

export const flushMultipleRedisCache = async (pluralNames: string[]) => {
    try {
        const response = await HttpClient.post(`${API_REDIX_CACHE_PATH}${REDIS_CACHE.BY_MULTI_CONTENT_TYPE.PATH}`, {
            pluralNames: pluralNames,
        })
        return response
    } catch (error) {
        console.error("Error flushing multiple redis cache:", error)
        throw error
    }
}

export const triggerRevalidate = async (name: string, value: string) => {
    const apiTrigger = process.env.NEXT_PUBLIC_REVALIDATE_URL
    if (!apiTrigger) return
    try {
        await fetch(`${apiTrigger}?${name}=${encodeURIComponent(value)}`)
    } catch {
        // fire-and-forget — don't block the save operation
    }
}